<template>
  <div>
    <ModalConfirm
      :showModal="open"
      imageProps="sunset.png"
      imageClass="mb-0"
      titleProps="Tukang Jagoan Telah Memiliki Jadwal"
      descProps="Silakan ganti tukang lainnya"
      descClass="c-w-95"
    >
      <template v-if="data" v-slot:additionalDesc>
        <div class="mt-4">
          <CardWorkerConflict
            className="bg-grey-8 border-radius-16"
            classNameBadge="bg-white"
            :data="data"
          />
        </div>
      </template>
      <template v-slot:button>
        <div class="c-w-100">
          <ButtonApp width="100%" @click="closeModal">
            <div>
              <p class="averta-bold py-2">Mengerti</p>
            </div>
          </ButtonApp>
        </div>
      </template>
    </ModalConfirm>
  </div>
</template>

<script>
export default {
  name: 'ModalErrorAssignWorker',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    }
  },
  components: {
    ModalConfirm: () => import('@/views/v2/am/vendor/components/ModalConfirm.vue'),
    ButtonApp: () => import('@/components/button/ButtonApp.vue'),
    CardWorkerConflict: () => import('@/components/card/CardWorkerConflict.vue')
  },
  methods: {
    closeModal () {
      this.$emit('closeModal')
    }
  }
}
</script>
